import { FormEvent, FormEventHandler, useEffect, useState } from "react";
import { useAddDienstleistungZuAuftragMutation, useDeaktivateDienstleistungZuAuftragMutation, useGetAuftragDienstleistungenMutation } from "../../../api/AuftragAPI";
import { useGetDienstleistungsListeMutation } from "../../../api/OfficeAPI";
import { IDienstleistung, IDienstleistungenFromAuftrag } from "../../../types/Types";
import { LoadingModal } from "../../LoadingModal/LoadingModal";
import { formatToEuroDate } from "../../../util/DateUtils";

type UploadFilesParameter = {
  uid: string
}

const AuftragTerminierenDienstleistungenComponent: React.FC<UploadFilesParameter> = ({ uid }) => {

  const [getAuftragDienstleistungenAPI] = useGetAuftragDienstleistungenMutation();
  const [getDienstleistungenAPI] = useGetDienstleistungsListeMutation();
  const [addDienstleistungZuAuftragAPi] = useAddDienstleistungZuAuftragMutation();
  const [deaktivateDienstleistungZuAuftragAPi] = useDeaktivateDienstleistungZuAuftragMutation();

  //const [removeDienstleistungAPI] = useRemoveAuftragFileMutation();
  const [dienstleistungenen, setDienstleistungen] = useState<IDienstleistung[]>([]);

  const [dienstleistungenVonAuftrag, setDienstleistungenVonAuftrag] = useState<IDienstleistungenFromAuftrag[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedDstlUid, setSelectedDstlUid] = useState<string>();

  const ladeListe = () => {
    //setIsLoading(true);
    getAuftragDienstleistungenAPI(uid).unwrap()
      .then(setDienstleistungenVonAuftrag)
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false))
      ;
  }

  useEffect(() => {
    if (!uid) return;
    ladeListe();
  }, [uid]);

  useEffect(() => {
    getDienstleistungenAPI().unwrap()
      .then(setDienstleistungen)
      .catch((error) => console.log(error))
      .finally(() => setIsLoading(false))
      ;
  }, [getDienstleistungenAPI]);

  const addDstl = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!selectedDstlUid) return;

    addDienstleistungZuAuftragAPi({ uid_auftrag: uid, uid_dstl: selectedDstlUid })
      .unwrap()
      .then(() => ladeListe())
      .catch((error) => console.log(error))
      ;
  }

  const removeDstl = (uid_dstl: string) => {
    if (!uid_dstl) return;

    deaktivateDienstleistungZuAuftragAPi({ uid_auftrag: uid, uid_dstl: uid_dstl })
      .unwrap()
      .then(() => ladeListe())
      .catch((error) => console.log(error))
      ;
  }

  return (
    <>

      <LoadingModal show={isLoading} />

      <div>
        <h4 style={{ marginTop: "15px" }}>Dienstleistungen</h4>
        <form onSubmit={addDstl} style={{ border: "1px solid #c5c5c5", backgroundColor: "#f4f4f4", padding: "1em", borderRadius: "3px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", }}>
            <div>
              <select name="selDstl" className="form-control" value={selectedDstlUid} onChange={(e) => setSelectedDstlUid(e.target.value)}>
                <option value={""}>-- Bitte auswählen --</option>
                {dienstleistungenen.filter(f => f.automatisch === false).map((e, index) =>
                  <>
                    <option key={index + "_Sel"} value={e.uid}>{e.text}</option>
                  </>
                )}
              </select>
            </div>
            <div>
              <button type="submit" className="btn btn-primary" ><i className="bi bi-plus"></i> Hinzufügen</button>
            </div>
          </div>
        </form >
        {
          dienstleistungenVonAuftrag.map((e, index) =>
            <>
              <div className="card">
                <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", padding: "10px", margin: "5px" }}>
                  <div>
                    {e.text}
                  </div>
                  <div style={{ textAlign: "end" }}>
                    <button className="btn btn-danger btn-sm" onClick={() => { if (window.confirm("Sind sie sicher, dass Sie die Dienstleistung löschen wollen?")) removeDstl(e.uid) }}><i className="bi bi-trash"></i></button>
                  </div>
                </div>
              </div>
            </>
          )
        }
      </div >

    </>
  )
}

export default AuftragTerminierenDienstleistungenComponent;